import { Breadcrumb } from 'antd';
import type { BreadcrumbProps } from 'antd';
import type { FC } from 'react';
import { Link, useLocation } from 'react-router';
import { navItems } from '@constants/routes/navItems';

// Human labels per path segment, derived from the nav metadata. '' is Home. A
// page's tabs are segments of their own, so their labels fold in alongside.
const LABELS: Record<string, string> = Object.fromEntries([
	...navItems.map(({ segment, label }) => [segment, label]),
	...navItems.flatMap(({ tabs = [] }) => tabs.map(({ segment, label }) => [segment, label])),
]);

const Breadcrumbs: FC = () => {
	const { pathname } = useLocation();

	const segments = pathname.split('/').slice(1);
	// Always start from the root ("Home") crumb.
	const parts = segments[0] === '' ? [''] : ['', ...segments];

	const items: BreadcrumbProps['items'] = parts.map((segment, index) => {
		const isLast = index === parts.length - 1;
		const url = '/' + parts.slice(1, index + 1).join('/');
		const label = LABELS[segment] ?? segment;

		return {
			key: index,
			title: isLast ? label : <Link to={url}>{label}</Link>,
		};
	});

	return <Breadcrumb items={items} />;
};

export default Breadcrumbs;
